import { render, staticRenderFns } from "./ArabicContractCandleInstallment.vue?vue&type=template&id=3901221a&scoped=true&"
import script from "./ArabicContractCandleInstallment.vue?vue&type=script&lang=js&"
export * from "./ArabicContractCandleInstallment.vue?vue&type=script&lang=js&"
import style0 from "./ArabicContractCandleInstallment.vue?vue&type=style&index=0&id=3901221a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3901221a",
  null
  
)

export default component.exports